import {
    Box,
    Grid,
} from "@chakra-ui/react";

import LoginShowcase from
    "../Login/components/LoginShowcase";

import ResetPasswordConfirmForm from
    "./components/ResetPasswordConfirmForm";

const ResetPasswordConfirm = () => {
    return (
        <Box
            h="100vh"
            overflow="hidden"
            bg="#F8FAFC"
            p={{
                base: 0,
                md: 8,
            }}
        >
            <Box
                maxW="1400px"
                mx="auto"
                h="100%"
                bg={{
                    base: "transparent",
                    md: "white",
                }}
                borderRadius={{
                    base: "0",
                    md: "24px",
                }}
                overflow="hidden"
                border={{
                    base: "none",
                    md: "1px solid",
                }}
                borderColor={{
                    md: "gray.200",
                }}
            >
                <Grid
                    h="100%"
                    templateColumns={{
                        base: "1fr",
                        lg: "1fr 1fr",
                    }}
                >
                    <ResetPasswordConfirmForm />

                    <LoginShowcase />
                </Grid>
            </Box>
        </Box>
    );
};

export default ResetPasswordConfirm;